import { cloneDeep } from 'lodash';
const SET_ACTIVE_FEATURED_SELECTION = 'SET_ACTIVE_FEATURED_SELECTION';

const initialState = {};

export default function reducer(state = cloneDeep(initialState), action) {
    switch (action.type) {
        case SET_ACTIVE_FEATURED_SELECTION:
            return {...action.payload};
        default:
            return state;
    }
}

export function setActiveFeaturedSelection(product){
    return{
        type: SET_ACTIVE_FEATURED_SELECTION,
        payload: product
    }
}



// WEBPACK FOOTER //
// ./src/modules/active_featured_selection.js